import { ReportType } from "../View/Products/Enums/ReportType";

export interface IMyReportsReport {
    jobId: string;
    jobType: ReportType;
    //TODO - convert "status" to an enum
    status: string;
    title: string;
    createdDateTime: Date;
    startDate: Date;
    endDate: Date;
  }